import { useRef } from 'react';

const useDoubleClick = () => {
  const timerRef = useRef(null);
  const targetRef = useRef('');
  const handleClick = function (targetId, onClick, onDoubleClick) {
    let skipOnClickIfDouble = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (timerRef.current && targetRef.current === targetId) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
      onDoubleClick();
    } else {
      timerRef.current = window.setTimeout(() => {
        timerRef.current = null;
        if (skipOnClickIfDouble) {
          onClick();
        }
      }, 300);
      targetRef.current = targetId;
      if (!skipOnClickIfDouble) {
        onClick();
      }
    }
  };
  return handleClick;
};
var useDoubleClick$1 = useDoubleClick;

export { useDoubleClick$1 as default };
//# sourceMappingURL=useDoubleClick.js.map
